function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.4142 0.585786C18.1953 1.36683 18.1953 2.63317 17.4142 3.41421L4.82843 16L17.4142 28.5858C18.1953 29.3668 18.1953 30.6332 17.4142 31.4142C16.6332 32.1953 15.3668 32.1953 14.5858 31.4142L0.585786 17.4142C-0.195262 16.6332 -0.195262 15.3668 0.585786 14.5858L14.5858 0.585786C15.3668 -0.195262 16.6332 -0.195262 17.4142 0.585786Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.4142 6.58579C21.1953 7.36683 21.1953 8.63317 20.4142 9.41421L13.8284 16L20.4142 22.5858C21.1953 23.3668 21.1953 24.6332 20.4142 25.4142C19.6332 26.1953 18.3668 26.1953 17.5858 25.4142L9.58579 17.4142C8.80474 16.6332 8.80474 15.3668 9.58579 14.5858L17.5858 6.58579C18.3668 5.80474 19.6332 5.80474 20.4142 6.58579Z",
  fill: "black"
});

function SvgReturnArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 32,
    viewBox: "0 0 21 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnArrowIcon);
export default __webpack_public_path__ + "static/media/returnArrow_icon.8ed45bf9.svg";
export { ForwardRef as ReactComponent };